// Rarity → all visual styles for items. Single source of truth for the
// border, glow, chip, AND the dynamic backdrop the browser composes behind
// transparent item assets.
//
// Convention: the `backdrop` block describes layered effects rendered by
// the `<ItemFrame>` component. Anything you change here propagates to
// inventory, marketplace, loot boxes, item detail, etc.
export const RARITIES = [
  {
    key: "Common",
    color: "#9aa3b3",
    glow: "rgba(154,163,179,0.4)",
    chip: "bg-[#1a2030] text-[#c8d4e3] border-[#3a4258]",
    backdrop: {
      base: "#0d1320",
      radialA: "rgba(154,163,179,0.18)",  // center
      radialB: "rgba(13,19,32,0)",        // edge
      energy: null,
      particles: "none",
      pulseMs: 0,
    },
  },
  {
    key: "Uncommon",
    color: "#5fd99a",
    glow: "rgba(95,217,154,0.5)",
    chip: "bg-[#0f2a1c] text-[#7eecb0] border-[#2a5e42]",
    backdrop: {
      base: "#091a13",
      radialA: "rgba(95,217,154,0.22)",
      radialB: "rgba(9,26,19,0)",
      energy: null,
      particles: "none",
      pulseMs: 0,
    },
  },
  {
    key: "Rare",
    color: "#3aa0ff",
    glow: "rgba(58,160,255,0.55)",
    chip: "bg-[#0e1f3a] text-[#7ec0ff] border-[#2a5d96]",
    backdrop: {
      base: "#08152c",
      radialA: "rgba(58,160,255,0.28)",
      radialB: "rgba(8,21,44,0)",
      energy: null,
      particles: "sparse",
      pulseMs: 0,
    },
  },
  {
    key: "Epic",
    color: "#a780ff",
    glow: "rgba(167,128,255,0.55)",
    chip: "bg-[#1f1235] text-[#c7a8ff] border-[#5a3e96]",
    backdrop: {
      base: "#150b28",
      radialA: "rgba(167,128,255,0.32)",
      radialB: "rgba(21,11,40,0)",
      // conic energy ring (animated rotation)
      energy: "conic-gradient(from 0deg, rgba(167,128,255,0.18), rgba(199,168,255,0.04), rgba(167,128,255,0.18), rgba(120,80,200,0.04), rgba(167,128,255,0.18))",
      particles: "sparse",
      pulseMs: 4200,
    },
  },
  {
    key: "Legendary",
    color: "#f3c552",
    glow: "rgba(243,197,82,0.55)",
    chip: "bg-[#2a1f08] text-[#ffd870] border-[#7a5a1c]",
    backdrop: {
      base: "#1d1505",
      radialA: "rgba(243,197,82,0.38)",
      radialB: "rgba(29,21,5,0)",
      energy: "conic-gradient(from 0deg, rgba(243,197,82,0.22), rgba(255,216,112,0.05), rgba(243,197,82,0.22), rgba(180,130,40,0.05), rgba(243,197,82,0.22))",
      particles: "dense",
      pulseMs: 3400,
    },
  },
  {
    key: "Mythic",
    color: "#e35a5a",
    glow: "rgba(227,90,90,0.6)",
    chip: "bg-[#2a0e0e] text-[#ff8a8a] border-[#7a2828]",
    backdrop: {
      base: "#220808",
      radialA: "rgba(227,90,90,0.42)",
      radialB: "rgba(34,8,8,0)",
      energy: "conic-gradient(from 0deg, rgba(227,90,90,0.26), rgba(255,138,138,0.05), rgba(227,90,90,0.26), rgba(180,40,40,0.05), rgba(227,90,90,0.26))",
      particles: "dense",
      pulseMs: 2800,
    },
  },
];

export const ITEM_TYPES = [
  "Raw Material",
  "Processed Material",
  "Weapon",
  "Helmet",
  "Chest",
  "Pants",
  "Boots",
  "Gloves",
  "Consumable",
  "Case",
  "Other",
];

export function rarityMeta(key) {
  return RARITIES.find(r => r.key === key) || RARITIES[0];
}
